export const CancelAddonTexts = {
  cancelAddon: 'Cancel Addon',
  modalTitle: 'Cancel ',
  modalDesc:
    'Are you sure you want to cancel this add-on? You’ll lose access to its features.',
  freeAiModalDesc:
    'Are you sure you want to cancel this add-on? You’ll lose access to its features, including all website slots added with AI visibility sites.',
  no: 'Keep it!',
  yes: 'Proceed',
  mainCancelTitle: 'Cancel Addon',
  aiVisibility: 'ai visibility',
  cardDesc:
    'Enter your card details to complete your add-on purchase. Your payment is secure and encrypted.'
};
